import type { TrapetsSettingsResponse } from "@repo/shared/types";
import { get } from "@/lib/api/_client";

const BASE = "/internal/trapets";

export function getSettings(): Promise<TrapetsSettingsResponse> {
  return get<TrapetsSettingsResponse>(BASE);
}
